import { useState } from 'react';
import { useLang } from '../../lib/language';

/**
 * Membership (subscription) invoice: the validity window, asked between the
 * cart and the payment window — the legacy till's "Membership date" From / To
 * on its order popup. Defaults today → today + 1 year, as legacy did; both are
 * editable. Dates only (YYYY-MM-DD); the server stores them on Inv_Membership.
 */
export function MembershipDatesDialog(props: {
  onCancel: () => void;
  onConfirm: (dates: { start: string; end: string }) => void;
}): JSX.Element {
  const { t } = useLang();
  const pad = (n: number) => String(n).padStart(2, '0');
  const ymd = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const today = new Date();
  const [start, setStart] = useState(ymd(today));
  const [end, setEnd] = useState(ymd(new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())));
  const isDate = (s: string) => /^\d{4}-\d{2}-\d{2}$/.test(s);
  // ISO dates compare correctly as strings.
  const valid = isDate(start) && isDate(end) && end > start;

  const confirm = () => {
    if (valid) props.onConfirm({ start, end });
  };

  return (
    <div className="modal-overlay show" onClick={(e) => { if (e.target === e.currentTarget) props.onCancel(); }}>
      <div className="modal" style={{ maxWidth: 420 }}>
        <div className="modal-header">
          <div className="modal-title">{t({ en: 'Membership dates', ar: 'تاريخ الاشتراك' })}</div>
          <button className="btn-close" onClick={props.onCancel} aria-label={t({ en: 'Close', ar: 'إغلاق' })}>×</button>
        </div>
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <label className="laundry-field">
              <span>{t({ en: 'From', ar: 'من' })}</span>
              <input type="date" value={start} onChange={(e) => setStart(e.target.value)} />
            </label>
            <label className="laundry-field">
              <span>{t({ en: 'To', ar: 'إلى' })}</span>
              <input type="date" value={end} min={start} onChange={(e) => setEnd(e.target.value)} />
            </label>
          </div>
          {isDate(start) && isDate(end) && end <= start && (
            <div role="alert" style={{ fontSize: 13, color: 'var(--danger, #dc2626)' }}>
              {t({ en: 'The end date must be after the start date.', ar: 'يجب أن يكون تاريخ النهاية بعد تاريخ البداية.' })}
            </div>
          )}
        </div>
        <div className="modal-footer" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', padding: '12px 20px' }}>
          <button type="button" className="btn-secondary" onClick={props.onCancel}>
            {t({ en: 'Cancel', ar: 'إلغاء' })}
          </button>
          <button type="button" className="btn-primary" disabled={!valid} onClick={confirm}>
            {t({ en: 'Continue to payment', ar: 'متابعة للدفع' })}
          </button>
        </div>
      </div>
    </div>
  );
}
